export enum SectionCompletionStatus {
  NONE = "NONE",
  PARTIAL = "PARTIAL",
  COMPLETE = "COMPLETE",
}
